import { appConfig } from './environment';

/**
 * API Client Configuration Bridge
 * 
 * This module provides configuration for the @taxassist/api-client package
 * when running in the frontend context, ensuring consistent configuration
 * between the frontend and API client.
 */

export interface ApiClientConfig {
  clientApi: string;
  adminApi: string;
  timeout: number;
  environment: string;
}

/**
 * Get API client configuration using the centralized environment config
 */
export function getApiClientConfig(): ApiClientConfig {
  return {
    clientApi: appConfig.api.baseUrl,
    adminApi: appConfig.api.adminBaseUrl,
    timeout: appConfig.api.timeout,
    environment: appConfig.environment
  };
}

/**
 * Configure the API client environment variables for consistency
 * This function sets the environment variables that the API client expects
 */
export function configureApiClientEnvironment(): void {
  // Set environment variables that the API client will use
  if (typeof window !== 'undefined') {
    // For browser environments, we'll inject these into the global scope
    // so the API client can access them via import.meta.env
    (window as any).__VITE_API_BASE_URL__ = appConfig.api.baseUrl;
    (window as any).__VITE_API_ADMIN_BASE_URL__ = appConfig.api.adminBaseUrl;
    (window as any).__VITE_API_TIMEOUT__ = appConfig.api.timeout.toString();
    (window as any).__VITE_ENVIRONMENT__ = appConfig.environment;
  }
  
  // Log configuration in development
  if (appConfig.isDevelopment) {
    console.log('🔌 API Client Configuration:', {
      clientApi: appConfig.api.baseUrl,
      adminApi: appConfig.api.adminBaseUrl,
      timeout: appConfig.api.timeout,
      environment: appConfig.environment
    });
  }
}